export default "__VITE_ASSET__02f2d1e8__"